import { render, staticRenderFns } from "./archive_tag_form.vue?vue&type=template&id=be066774&"
import script from "./archive_tag_form.vue?vue&type=script&lang=js&"
export * from "./archive_tag_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports